<template>
  <div>
    <Header />
    <div class="dash-body">
      <div class="dash-header">
        <div class="dash-caption reports-page">
          {{ $t('REPORTS_REPORT') }}
          <button class="btn-st-red" @click="INTRO_SET_AUTOREPORTS_SETTINGS_VISIBLE(true)">{{ $t('REPORTS_MANAGE') }}</button>
        </div>
        <div class="dash-options">
          <calendar :callback="setPage" />
        </div>
      </div>
      <div class="p-list reports-tab">
        <div v-if="!getReports || getReports.length === 0" class="no-reports-placeholder">
          <p class="no-reports-text">{{ $t('REPORTS_NO_REPORTS_YET') }}</p>
        </div>
        <table v-else>
          <tbody>
            <tr :key="index" v-for="(report, index) in getReports">
              <td>{{ report.type }}</td>
              <td>
                {{ $t('REPORTS_LIST') }} 
                <span v-for="(page, pIdx) in getReportPages(report)" :key="'p'+pIdx">
                  <a :href="page.url" target="_blank" :title="page.fullName">{{ page.displayName }}</a><template v-if="pIdx < getReportPages(report).length - 1">, </template>
                </span>
                {{ $t('REPORTS_LIST_PRD') }} 
                <b
                  >{{ moment(report.from).format("YYYY-MM-DD") }} -
                  {{ moment(report.to).format("YYYY-MM-DD") }}</b
                >
                {{ $t('REPORTS_WAS') }} 
                <b>{{ moment(report.date).format("YYYY-MM-DD, HH:mm") }}</b>
              </td>
              <td
                class="reports-export"
                @click="download(report.hash_id, report.type)"
              >
                {{ $t('REPORTS_DOWNLD') }} 
              </td>
              <td>
                <span
                  class="close"
                  @click="DELETE_REPORT({ id: report.id, type: report.type })"
                  ><i class="bi bi-x-lg"></i></span
                >
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import Header from "../components/Header";
import Calendar from "../components/Calendar";
import { mapGetters, mapMutations, mapActions } from "vuex";
import {
  REPORTS_GET,
  REPORTS_DOWNLOAD,
  DELETE_REPORT,
} from "../store/actions/reports";
import {
  INTRO_SET_AUTOREPORTS_SETTINGS_VISIBLE,
  INTRO_SET_PAGES,
  INTRO_SET_PERIOD,
} from "../store/actions/intro";

export default {
  name: "ReportsList",
  components: {
    Header,
    Calendar,
  },
  computed: {
    ...mapGetters(["getSelectedPages", "getPeriod", "getReports", "getPages", "isPagesLoaded"]),
  },
  methods: {
    ...mapMutations([INTRO_SET_AUTOREPORTS_SETTINGS_VISIBLE, INTRO_SET_PERIOD]),
    ...mapActions([
      REPORTS_GET,
      REPORTS_DOWNLOAD,
      DELETE_REPORT,
      INTRO_SET_PAGES,
    ]),
    setPage() {
      this.REPORTS_GET();
    },
    getReportPages(report) {
      const names = Array.isArray(report.names)
        ? report.names
        : (report.names || '').split(',').map(n => n.trim());

      const pages = this.getPages || [];
      return names.filter(name => name).map(name => {
        const match = pages.find(p => p.fullowner_name === name || p.owner_name === name);
        const fullName = name;
        return {
          fullName,
          displayName: fullName.length > 25 ? fullName.substring(0, 25) + '...' : fullName,
          url: match ? match.owner_url : '/',
        };
      });
    },
    download: function (hashId, type) {
      this.$store.dispatch(REPORTS_DOWNLOAD, { hashId, type }).then((response) => {
        if (response.status != 200) return;

        const fileURL = window.URL.createObjectURL(response.data);
        const fileLink = document.createElement("a");
        fileLink.href = fileURL;
        fileLink.setAttribute("download", `file.${type}`);
        fileLink.click();
      });
    },
  },
  async mounted() {
    this.setPage();
    if (!this.isPagesLoaded) {
      if (!this.getPeriod) {
        this.INTRO_SET_PERIOD({
          start: this.moment().subtract(30, "days").format("YYYY-MM-DD"),
          end: this.moment().subtract(1, "days").format("YYYY-MM-DD"),
        });
      }
      await this.INTRO_SET_PAGES();
    }
  },
};
</script>

<style>
</style>